<template>
    <div class="recursionTab" style="float: left;max-width: 1000px"  :class="theme+'-recursionTab'">


          <ul ref="isFirst" style="transition:all 0.8s;overflow: hidden" :style="!Open&&isFirst?'height: 80px':'height:initial'" :class="{'noFirst':!isFirst}">
              <li v-for="(item,index) in tree" class="item recursionTab-item" :class="[{'selected':dept==item.id},{'disabled_li':editIng&&!isDept}]"
                  @click.stop="clickBack(item)">{{item.name}}
                  <el-popover
                          placement="bottom-start"
                          width="400"
                          trigger="hover"
                          >
                      <recursionTab :dept="dept" v-if="!editIng&&item.children&&item.children.length>0" @selectDept="selectDept" :tree="item.children||[]"/>
                      <i class="el-icon-caret-bottom"  slot="reference" v-if="item.children&&item.children.length>0">       </i>
                  </el-popover>

              </li>
              <slot name="swtch"></slot>
          </ul>
          <div class="switch-open" v-if="isFirst&&showOpen">
              <i :class="Open?'el-icon-d-arrow-left':'el-icon-d-arrow-right'" style="transform: rotate(90deg);"  @click="switchOpen"></i>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: "recursionTab",
        props:{
            isFirst:{

            },
            tree:{

            },
            dept:{

            },
            editIng:{

            },
            isDept:{

            }

        },
        data(){
            return {
                showLength:12,
                Open:true,
                showOpen:false
            }
        },
        computed: {
            ...mapGetters(["theme"]),
        },
        mounted(){
            this.$nextTick(()=>{
                if(this.isFirst){
                    if(this.$refs.isFirst.offsetHeight>100){
                        this.Open=false
                        this.showOpen=true
                    }else{
                        this.Open=false
                    }
                }

            })
        },
        methods:{
            clickBack(item){
                if(this.editIng){
                    return;
                }
                this.$emit('selectDept',item)
            },
            selectDept(item){
                this.$emit('selectDept',item)
            },
            switchOpen(){
                this.Open=!this.Open
            }
        }
    }
</script>

<style scoped lang="less">
    ul{
        float: left;
        >.handle{
            display: inline-block;
            >img{
                width: 20px;
                padding-top: 5px;
                cursor: pointer;
            }

        }
    >.item{
        position: relative;
        display: inline-block;
        padding: 5px 14px;
        margin: 0 10px;
        background: #F2F3F6;
        border-radius: 40px;
        color: #000;
        cursor: pointer;
        min-width: 50px;
        text-align: center;
        margin-bottom: 14px;
        &.disabled_li{
            cursor: not-allowed!important;
            opacity: 0.7;
            &.selected{
                background: rgba(122, 188, 243,0.4)!important;
                color: #ccc!important;
            }
        }
        /deep/.recursionTab{
            position: absolute;
            top:25px;
            /*display: none;*/
            padding: 5px 20px 20px 20px;
            z-index: 100;
            border-radius: 5px;
            border-top: 5px solid transparent;
            width: 400px;
            &:after {
                content: '';
                display: block;
                width: 0;
                height: 0;
                border: 8px solid transparent;
                position: absolute;
                top: -10px;
                z-index: 111;
                border-bottom: 8px solid white;
                left: 20px;

            }
            >ul{
                box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
                background: white;
                border-radius: 5px;

                &.noFirst{
                    padding: 7px 0;
                    text-align: left;
                    >.item{
                       margin-bottom: 7px;
                        margin-top: 7px;
                    }
                }

            }
        }

    &.selected{
         cursor: text;
         color: #fff;
         font-weight: bold;
        /deep/ul{
            font-weight: initial;
        }
         /*box-shadow: 0 2px 4px rgba(72, 164, 239,0.4), 0 0 6px rgba(72, 164, 239,0.4);*/
     }

    }

    }

.switch-open{
    text-align: center;
    width: 50px;
    margin: 0 auto;
    color: #218dee;
    width: 100%;
    float: left;
    i{
        cursor: pointer;
    }
}
    .theme-w-recursionTab,
    .theme-swl-recursionTab,
    .theme-qxl-recursionTab,
    .theme-dlz-recursionTab{
        .item{
            &.selected{
                background: #48A4EF;
            }
        }
    }
</style>
